//useGroupPaymentCardInfo - return payment card details

import { useLoadTrips } from 'customHooks/useLoadTrips';

const debug = false;

const getCardNumber = (card: any) => {
  return card?.transaction?.creditCardNumber || card?.creditCardNumber || '';
};

const getCardLastFourDigits = (card: any) => {
  const cardNumber = String(getCardNumber(card)).replace(/\s/g, '');

  return cardNumber.slice(-4);
};


const formatMaskedCardNumber = (cardNumber: string) => {
    const cleanCardNumber = String(cardNumber).replace(/\s/g, '');
  
    return cleanCardNumber.match(/.{1,4}/g)?.join(' ') || '';
  };

const getFormattedExpirationDate = (card: any) => {
    const expirationDate =
      card?.transaction?.cardExpirationDate ||
      card?.cardExpirationDate ||
      '';
  
    const clearExpiry = String(expirationDate).replace(/[^\d]/g, '');
  
    if (clearExpiry.length === 4) {
      return `${clearExpiry.slice(0, 2)}/${clearExpiry.slice(2)}`;
    }
  
    return expirationDate;
  };

export const useGroupPaymentCardInfo = (groupId: string) => {
    const { trips, loading, paymentCards = [] } = useLoadTrips();


  if (debug) {
    console.log ('[useGroupPaymentCardInfo]paymentCards:', paymentCards);
  }

  const group = trips?.[groupId];

  const currentPaymentCard =
    paymentCards.find(
      (card: any) => String(card.groupId) === String(groupId) && card.isPrimary
    ) ||
    paymentCards.find(
      (card: any) => String(card.groupId) === String(groupId)
    );

  const holdAmount = (group?.bills || [])
    .reduce((acc: number, bill: any) => acc + (bill.total || 0), 0)
    .toFixed(2);

  const cardLastFourDigits = getCardLastFourDigits(currentPaymentCard);
  const maskedCardNumber = formatMaskedCardNumber(
    currentPaymentCard?.transaction?.creditCardNumber || ''
  );


  const expirationDate = getFormattedExpirationDate(currentPaymentCard );

  const cardHolderName = currentPaymentCard?.holderName;

  const postalCode = currentPaymentCard?.postalCode || '';
  const city = currentPaymentCard?.city || '';
  const province = currentPaymentCard?.province || '';
  const streetAddress = currentPaymentCard?.streetAddress || '';
  const streetAddressLine2 = currentPaymentCard?.streetAddressLine2 || '';
  const country = currentPaymentCard?.country || '';
  
  const billingAddress = [
   
    streetAddress,
    streetAddressLine2,
    city,
    province,
    country,
    postalCode
  ]
    .filter((addressPart) => String(addressPart).trim())
    .join(', ');
  
  
  return {
    loading,
    group,
    currentPaymentCard,
    holdAmount,
    expirationDate,
    billingAddress,
    maskedCardNumber,
    cardLastFourDigits,
    cardHolderName
  };
};